<template>
  <section class="terms">
    <h2>개인정보 수집 동의<span class="text--required">(필수)</span></h2>
    <ol>
      <li>
        <span class="label">1.</span>
        수집하는 개인정보 항목 : 이름, 휴대전화번호, 배송지 주소
      </li>
      <li>
        <span class="label">2.</span>
        개인정보의 수집 및 이용목적 : 상품 서비스 제공, 고객상담, 불만처리 등 배송 민원 처리
      </li>
      <li>
        <span class="label">3.</span>
        개인정보의 이용기간 :
        <br>
        <b class="fs-md">(일반회원) 회원 탈퇴 시,<br>(기업회원) 위탁 계약 종료 시 까지</b>
      </li>
    </ol>
    <ol>
      <li>
        <span class="label">*</span>동의를 거부할 수 있으나 동의 거부 시 서비스 이용이 제한 됩니다
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  name: 'PrivacyCollectionTerms'
}
</script>

<style scoped>

</style>
